
// 表格行
export class HdTableColumn {
  title: string;  // 列名
  name: string | Function = null;  // 字段名
  render?: (value: any) => string;  // 渲染函数
  width?: number; // 列宽
  /**
   * 文字颜色。
   * 字符串：整列同色；
   * 函数：按行返回颜色（如标红返回 '#F5222D'，不标色返回空）。
   */
  color?: string | ((line: any) => string);
  align?: 'right' | 'left' | 'center' = 'left';
  click?: (value: any) => void;
  /** 按行控制是否渲染为可点击超链接；未配置时只要有 click 则整列可点 */
  canClick?: (value: any) => boolean;
  fixed?: 'left' | 'right' = null;
  fixedWidth?: number;  // 左侧固定列偏移（其左侧已固定列宽之和）
  fixedRightWidth?: number;  // 右侧固定列偏移（其右侧已固定列宽之和）
  btnList?: Array<OperateBtn> = []; // title 为「操作」时整列按钮；其他列时作为单元格文案后的操作按钮
  isShow?: boolean = true;
  canSort?: boolean = false; // 是否可以排序
  canWarp?: boolean = false; // 用于某一列需要个性化的场景，当为true时，且表格选项showOperateColWarpButton为true时，通过按钮控制对应的列是否换行
  minWidth?: number; // 最小宽度，保证列名能正常显示
  stateField?: string; // 状态列取值字段，默认取 state
  isState?: boolean; // 是否按状态列渲染，取值字段为 name
  /**
   * 字段值后用竖线追加行号。前面的字段仍可配 click 作为超链接，行号本身不可点。
   * true：按分页连续序号（从 1 开始）；
   * string：取当前行该字段作为行号。
   */
  rowNo?: boolean | string;
  /**
   * 值后显示编辑笔图标（Figma edit/edit，14px）。
   * true：整列可编辑；函数：按行控制。
   */
  editable?: boolean | ((line: any) => boolean);
  /** 点击编辑笔回调，供父组件处理（如弹窗改值） */
  edit?: (line: any) => void;
}

export class OperateBtn {
  /** 按钮文案；支持按行动态，如 (line) => line.enabled ? '解除' : '设置' */
  name: string | ((line: any) => string);
  showConfirm?: boolean | ((line: any) => boolean) = false;
  isRepeat?: boolean = false; // 是否和别的按钮有显示冲突，譬如：开启，关闭需要再关闭按钮加一个这个属性
  click?: (value: any) => void;
  permission?: (value: any) => boolean;
}

export class HdTableTotalOption {
  columnNumber: number; // 总列数
  insertIndex: number; // 插入下标
  insertName: string; // 插入字段
}

export class TableCacheOption {
  pageSize: number;
  colWidths: Map<string, number> = new Map<string, number>(); // name -> width
  cols: Array<string>; // ['title']
}

// 设置列 树组件对象
export class TreeGrid {
  title: string = '';
  key: string = '';
  disabled?: boolean = false;
  checked?: boolean = false;
  selectable?: boolean = false;
  isLeaf?: boolean = true;
  expanded?: boolean = false;
}